import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import BestSpreadsheetArticle from "@/pages/articles/BestSpreadsheetArticle";
import LatestUpdatesArticle from "@/pages/articles/LatestUpdatesArticle";
import UpdatedGuideArticle from "@/pages/articles/UpdatedGuideArticle";
import TrustedDirectoryArticle from "@/pages/articles/TrustedDirectoryArticle";
import BestNikeArticle from "@/pages/articles/BestNikeArticle";
import BestJordanArticle from "@/pages/articles/BestJordanArticle";
import BestSneakerArticle from "@/pages/articles/BestSneakerArticle";
import BestBagArticle from "@/pages/articles/BestBagArticle";
import BestHoodieArticle from "@/pages/articles/BestHoodieArticle";
import QCExamplesArticle from "@/pages/articles/QCExamplesArticle";
import ShoppingGuideArticle from "@/pages/articles/ShoppingGuideArticle";
import TrustedSellersArticle from "@/pages/articles/TrustedSellersArticle";
import CommunityPicksArticle from "@/pages/articles/CommunityPicksArticle";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/articles/best-superbuy-spreadsheet-2026", element: <BestSpreadsheetArticle /> },
  { path: "/articles/latest-superbuy-spreadsheet-updates", element: <LatestUpdatesArticle /> },
  { path: "/articles/updated-superbuy-spreadsheet-guide", element: <UpdatedGuideArticle /> },
  { path: "/articles/trusted-superbuy-spreadsheet-directory", element: <TrustedDirectoryArticle /> },
  { path: "/articles/best-nike-superbuy-spreadsheet", element: <BestNikeArticle /> },
  { path: "/articles/best-jordan-superbuy-spreadsheet", element: <BestJordanArticle /> },
  { path: "/articles/best-sneaker-superbuy-spreadsheet", element: <BestSneakerArticle /> },
  { path: "/articles/best-bag-superbuy-spreadsheet", element: <BestBagArticle /> },
  { path: "/articles/best-hoodie-superbuy-spreadsheet", element: <BestHoodieArticle /> },
  { path: "/articles/real-qc-superbuy-spreadsheet-examples", element: <QCExamplesArticle /> },
  { path: "/articles/superbuy-spreadsheet-shopping-guide", element: <ShoppingGuideArticle /> },
  { path: "/articles/trusted-sellers-superbuy-spreadsheet", element: <TrustedSellersArticle /> },
  { path: "/articles/superbuy-spreadsheet-community-picks", element: <CommunityPicksArticle /> },
  { path: "*", element: <NotFound /> },
];

export default routes;